import history from 'shared/util/routing/history'

export function goToQuote(args: { id: string; invoice?: boolean; hash?: string; params?: Record<string, string> }) {
  const { invoice, id, hash, params } = args
  const baseUrl = invoice ? 'invoices' : 'quotes'

  return history.push(
    `/${baseUrl}/edit/${id}${hash ? '#' + hash : ''}${params ? '?' + new URLSearchParams(params).toString() : ''}`
  )
}
